import { createSlice } from "@reduxjs/toolkit";
import { LocationSelectedDetails } from "../../actions/locations/locationsTypes";
import {
  BinSelectedInfo,
  StoragesValuesView,
} from "../grainTracker/grainTrackerTypes";
import { resetBinStorage } from "../../actions/locations/locationDetailsAsync";
import { logOut } from "../layout";

export interface SingleLocationState {
  locationSelectedDetails: LocationSelectedDetails | undefined;
  isBinSelected: boolean;
  selectedBin: {
    values: undefined | BinSelectedInfo;
    loading: boolean;
    error: string;
  };
  locationViewValues: {
    storages: StoragesValuesView[];
    storagesViewTotal: number;
    loading: boolean;
    error: string;
  };

  resetStorageCapacity: {
    loading: boolean;
    error: string;
    success: boolean;
  };
  isLocationShared: boolean;
}

export const initialState: SingleLocationState = {
  locationSelectedDetails: undefined,
  isBinSelected: false,
  locationViewValues: {
    storages: [],
    storagesViewTotal: 0,
    loading: false,
    error: "",
  },

  selectedBin: {
    values: undefined,
    loading: false,
    error: "",
  },

  resetStorageCapacity: {
    loading: false,
    error: "",
    success: false,
  },
  isLocationShared: false,
};

export const SingleLocationSlice = createSlice({
  name: "SingleLocationReducer",
  initialState,
  reducers: {
    setIsLocationShared(state, action) {
      return {
        ...state,
        isLocationShared: action.payload,
      };
    },
    setLocationViewValues(state, action) {
      return {
        ...state,
        locationViewValues: action.payload,
      };
    },

    setSelectedBinValues(state, action) {
      return {
        ...state,
        selectedBin: action.payload,
      };
    },

    setIfBinIsSelected(state, action) {
      return {
        ...state,
        isBinSelected: action.payload,
      };
    },

    resetBinSelection(state) {
      return {
        ...state,
        isBinSelected: false,
        selectedBin: {
          values: undefined,
          loading: false,
          error: "",
        },
      };
    },

    setLocationSelectedDetails(state, action) {
      return {
        ...state,
        locationSelectedDetails: action.payload,
      };
    },

    resetSingleLocation() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(resetBinStorage.pending, (state) => {
        state.resetStorageCapacity.loading = true;
        state.resetStorageCapacity.error = "";
      })
      .addCase(resetBinStorage.fulfilled, (state) => {
        state.resetStorageCapacity.loading = false;
        state.resetStorageCapacity.success = true;
      })
      .addCase(resetBinStorage.rejected, (state, action) => {
        state.resetStorageCapacity.loading = false;
        state.resetStorageCapacity.error = action.payload as string;
      });

    builder.addCase(logOut, () => {
      return initialState;
    });
  },
});

export const {
  resetBinSelection,
  setIsLocationShared,
  resetSingleLocation,
  setLocationViewValues,
  setSelectedBinValues,
  setIfBinIsSelected,
  setLocationSelectedDetails,
} = SingleLocationSlice.actions;

export const SingleLocation = SingleLocationSlice.reducer;
